import { render } from "./ContactanosComponent.vue?vue&type=template&id=43066a44"
import script from "./ContactanosComponent.vue?vue&type=script&lang=js"
export * from "./ContactanosComponent.vue?vue&type=script&lang=js"

import "./ContactanosComponent.vue?vue&type=style&index=0&id=43066a44&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__